<template>
    <div class="block-editor suppression-add">
        <div class="editor-row">
            <div class="editor-row-title">Type</div>
            <a-select class="classic-new-select" placeholder="Ban Type" v-model="clone.type" :options="types" />
        </div>
        <div class="editor-row" v-if="clone.type && clone.type !== 'web-visitor'">
            <div class="editor-row-title">Value</div>
            <TiptapEditor
                placeholder="Value"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.value"
            />
        </div>
        <div class="editor-row customize-editor" v-if="clone.type">
            <div class="editor-row-title">Inbound</div>
            <a-switch un-checked-children="✔" checked-children="✖" v-model:value="clone.inbound" />
        </div>
        <div class="editor-row customize-editor" v-if="clone.type">
            <div class="editor-row-title">Outbound</div>
            <a-switch un-checked-children="✔" checked-children="✖" v-model:value="clone.outbound" />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";

const log = log2("SuppressionAdd");
export default {
    name: "SuppressionAdd",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            types: [
                {
                    value: "whatsapp",
                    label: "Whatsapp",
                },
                {
                    value: "web-visitor-ip",
                    label: "Web Visitor IP",
                },
                {
                    value: "web-visitor",
                    label: "Web Visitor",
                },
                {
                    value: "email",
                    label: "Mail",
                },
            ],
            pipelines: [],
        };
    },

    mounted() {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.suppression-add {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }

    .classic-new-select {
        width: 100%;
        font-weight: bold;

        [role="combobox"] {
            padding: 4px;
            border: none !important;
            border-radius: 4px !important;
            background-color: #f1f1f1 !important;
        }
    }

    .customize-editor {
        &-minimize {
            .editable-editor {
                background-color: #6c757d;

                .ProseMirror {
                    color: white;
                }
            }
        }

        .editable-editor {
            background-color: #6c757d;

            .ProseMirror {
                color: white;
                height: 100px;
            }
        }
    }
}
</style>
